import { gsap, TweenMax, TweenLite } from "gsap";
import ScrollMagic from "scrollmagic";

window.addEventListener("load", () => {
  if (window.innerWidth < 768) {
    initMobileCanvasScene();
  } else {
    initDesctopCanvasScene();
  }
});

function DegToRadian(deg) {
  return deg * (Math.PI / 180);
}

function initMobileCanvasScene() {
  var canvas = document.querySelector("#js-canvas-animation");
  var lang = canvas.dataset.lang ? canvas.dataset.lang : "ru";
  var wrpa = canvas.closest("div");
  canvas.width = wrpa.clientWidth;
  var scale_factor = 1;
  scale_factor = wrpa.clientWidth / 320;
  canvas.height = 300 * scale_factor;
  var ctx = canvas.getContext("2d");
  var canvasWidth = canvas.width;
  var canvasHeight = canvas.height;
  let cw = canvas.width;
  let ch = canvas.height;

  // RETINA SCALE
  if (window.devicePixelRatio > 1) {
    canvas.width = canvasWidth * window.devicePixelRatio;
    canvas.height = canvasHeight * window.devicePixelRatio;
    canvas.style.width = canvasWidth + "px";
    canvas.style.height = canvasHeight + "px";
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
  }

  let globalcenter_x = 100 * scale_factor;
  let globalcenter_y = 230 * scale_factor;
  let global_radius = 220 * scale_factor;
  let line_step = 40 * scale_factor;
  let speed_sacel = 0.6;

  class Line_1 {
    constructor() {
      this.time = 2.2 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 5;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(180), end: DegToRadian(180) },
        { start: DegToRadian(268), end: DegToRadian(336) }
      );
    }

    draw() {
      ctx.save();
      ctx.strokeStyle = "#EB6063";
      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Line_2 {
    constructor() {
      this.time = 1 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius - line_step;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 2;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(180), end: DegToRadian(180) },
        {
          start: DegToRadian(273),
          end: DegToRadian(375),
          delay: 1.2 * speed_sacel,
        }
      );
    }

    draw() {
      ctx.save();

      ctx.strokeStyle = "#EB6063";

      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.setLineDash([0.67, 3.36]);
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Line_3 {
    constructor() {
      this.time = 1.5 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius - line_step * 2;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 1;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(180), end: DegToRadian(180) },
        {
          start: DegToRadian(180),
          end: DegToRadian(350),
          delay: 1.5 * speed_sacel,
        }
      );
    }

    draw() {
      ctx.save();

      ctx.strokeStyle = "#EB6063";

      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.setLineDash([4, 2]);
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Line_4 {
    constructor() {
      this.time = 1.2 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius - line_step * 3;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 1;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(180), end: DegToRadian(180) },
        {
          start: DegToRadian(265),
          end: DegToRadian(350),
          delay: 1.4 * speed_sacel,
        }
      );
    }

    draw() {
      ctx.save();

      ctx.strokeStyle = "#EB6063";

      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Text {
    constructor(message, x, y, delay) {
      this.time = 1 * speed_sacel;

      this.message = message.toUpperCase();
      this.x = x * scale_factor;
      this.y = y * scale_factor;
      this.delay = delay;
      this.opacity = 0;

      this.fontSize = 8 * scale_factor;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { opacity: 0 },
        { opacity: 1, delay: delay * speed_sacel }
      );
    }

    draw() {
      ctx.save();

      ctx.fillStyle = "rgba(0, 0, 0, " + this.opacity + ")";
      ctx.font = this.fontSize + "px Gilroy";
      ctx.fillText(this.message, this.x, this.y);

      ctx.restore();
    }
  }

  let displayObjects = [
    new Line_1(),
    new Line_2(),
    new Line_3(),
    new Line_4(),
    new Text(lang == "ru" ? "медиасервис" : "media service", 24, 12, 2),
    new Text(lang == "ru" ? "perfomance" : "perfomance", 47, 53, 2.3),
    new Text(lang == "ru" ? "UX-анализ" : "UX analysis", 37, 135, 2.5),
    new Text(
      lang == "ru" ? "web-разработка" : "web development",
      136,
      228,
      2.6
    ),
    new Text(lang == "ru" ? "PR" : "PR", 233, 219, 2.8),
    new Text(lang == "ru" ? "SMM" : "SMM", 262, 292, 3),
  ];

  for (let i = 0; i < displayObjects.length; i++) {
    displayObjects[i].animation.pause();
  }

  // init controller
  var controller = new ScrollMagic.Controller();
  // build scene
  let is_paly = false;
  let scene = new ScrollMagic.Scene({
    triggerElement: "#js-trigger-animation",
    offset: -350,
  })
    .addTo(controller)
    .on("start end", (e) => {
      if (!is_paly) {
        is_paly = true;

        for (let i = 0; i < displayObjects.length; i++) {
          displayObjects[i].animation.play();
        }
      }
    });

  gsap.globalTimeline.eventCallback("onUpdate", function () {
    render();
  });

  function render() {
    ctx.clearRect(0, 0, cw, ch);
    for (let i = 0; i < displayObjects.length; i++) {
      displayObjects[i].draw();
    }
  }
}


function initDesctopCanvasScene() {
  var canvas = document.querySelector("#js-canvas-animation");
  var lang = canvas.dataset.lang ? canvas.dataset.lang : "ru";
  var wrpa = canvas.closest("div");
  canvas.width = wrpa.clientWidth;
  var scale_factor = 1;

  scale_factor = wrpa.clientWidth / 1280;
  // console.log(scale_factor);
  canvas.height = (711 + 113) * scale_factor;

  if (window.innerWidth >= 1366) {
    canvas.height = 802;
  }

  var ctx = canvas.getContext("2d");

  var canvasWidth = canvas.width;
  var canvasHeight = canvas.height;

  let cw = canvas.width;
  let ch = canvas.height;

  // RETINA SCALE
  if (window.devicePixelRatio > 1) {
    canvas.width = canvasWidth * window.devicePixelRatio;
    canvas.height = canvasHeight * window.devicePixelRatio;
    canvas.style.width = canvasWidth + "px";
    canvas.style.height = canvasHeight + "px";
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
  }

  let all_x = -20; //100;
  let all_y = -14;

  let globalcenter_x = (646 + all_x) * scale_factor;
  let globalcenter_y = (478 + all_y) * scale_factor;
  let global_radius = 447 * scale_factor;
  let line_step = 65 * scale_factor;
  let speed_sacel = 0.6;

  class Line_1 {
    constructor() {
      this.time = 2.2 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 5;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(90), end: DegToRadian(-270) },
        { start: DegToRadian(226.5), end: DegToRadian(-15.5) }
      );
    }

    draw() {
      ctx.save();
      ctx.strokeStyle = "#EB6063";
      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Line_2 {
    constructor() {
      this.time = 1 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius - line_step;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 2;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(90), end: DegToRadian(-180) },
        {
          start: DegToRadian(250),
          end: DegToRadian(30),
          delay: 1.2 * speed_sacel,
        }
      );
    }

    draw() {
      ctx.save();

      ctx.strokeStyle = "#EB6063";

      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.setLineDash([0.67, 3.36]);
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Line_3 {
    constructor() {
      this.time = 1.5 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius - line_step * 2;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 1;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(90), end: DegToRadian(-270) },
        {
          start: DegToRadian(224),
          end: DegToRadian(-5),
          delay: 1.5 * speed_sacel,
        }
      );
    }

    draw() {
      ctx.save();

      ctx.strokeStyle = "#EB6063";

      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.setLineDash([4, 2]);
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Line_4 {
    constructor() {
      this.time = 1.2 * speed_sacel;

      this.x = globalcenter_x;
      this.y = globalcenter_y;
      this.radius = global_radius - line_step * 3;
      this.start = 0;
      this.end = 0;
      this.lineWidth = 1;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { start: DegToRadian(180), end: DegToRadian(180) },
        {
          start: DegToRadian(252),
          end: DegToRadian(339),
          delay: 1.4 * speed_sacel,
        }
      );
    }

    draw() {
      ctx.save();

      ctx.strokeStyle = "#EB6063";

      ctx.beginPath();
      ctx.lineWidth = this.lineWidth;
      ctx.arc(this.x, this.y, this.radius, this.start, this.end);
      ctx.stroke();
      ctx.restore();
    }
  }

  class Text {
    constructor(message, x, y, delay) {
      this.time = 1 * speed_sacel;

      this.message = message.toUpperCase();
      this.x = (x + all_x) * scale_factor;
      this.y = (y + all_y) * scale_factor;
      this.delay = delay;
      this.opacity = 0;

      this.fontSize = 10 * scale_factor;

      this.animation = TweenMax.fromTo(
        this,
        this.time,
        { opacity: 0 },
        { opacity: 1, delay: delay * speed_sacel }
      );
    }

    draw() {
      ctx.save();

      ctx.fillStyle = "rgba(0, 0, 0, " + this.opacity + ")";
      ctx.font = this.fontSize + "px Gilroy";
      ctx.fillText(this.message, this.x, this.y);

      ctx.restore();
    }
  }

  let displayObjects = [
    new Line_1(),
    new Line_2(),
    new Line_3(),
    new Line_4(),
    new Text(lang == "ru" ? "медиасервис" : "media service", 283, 176, 2),
    new Text(lang == "ru" ? "perfomance" : "perfomance", 459, 146, 2.3),
    new Text(
      lang == "ru" ? "маркетинг влияния" : "influence marketing",
      350,
      280,
      2.3
    ),
    new Text(
      lang == "ru" ? "web-разработка" : "web development",
      839,
      420,
      2.6
    ),
    new Text(lang == "ru" ? "PR" : "PR", 958, 470, 2.8),
    new Text(lang == "ru" ? "SMM" : "SMM", 1066, 380, 3),
  ];

  for (let i = 0; i < displayObjects.length; i++) {
    displayObjects[i].animation.pause();
  }

  // init controller
  var controller = new ScrollMagic.Controller();
  // build scene
  let is_paly = false;
  let scene = new ScrollMagic.Scene({
    triggerElement: "#js-trigger-animation",
    offset: -350,
  })
    .addTo(controller)
    .on("start end", (e) => {
      if (!is_paly) {
        is_paly = true;

        for (let i = 0; i < displayObjects.length; i++) {
          displayObjects[i].animation.play();
        }
      }
    });

  gsap.globalTimeline.eventCallback("onUpdate", function () {
    render();
  });

  function render() {
    ctx.clearRect(0, 0, cw, ch);
    for (let i = 0; i < displayObjects.length; i++) {
      displayObjects[i].draw();
    }
  }
}
